import React, { Component } from 'react'
import { Container, Toolbar, SearchField, Button, Label } from '@sencha/ext-modern'
import Message from 'tyan/components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import { WX } from 'tyan/public'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class InstrumentUsageQuery extends Component {
    state = {
        query: this.props.match.params.query || '',//test0221 -> CE2A3E21099DF441EB0A92073042B609  http://localhost:1980/#/QYWX/InstrumentQuery/CE2A3E21099DF441EB0A92073042B609
        queryText: '',
        nameText: '',
        loading: false,
        errorMessage: null,
        instrumentUsageList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetInstrumentUsageList(pageCount)
    }

    handleScanQRCode = () => {
        WX.scanQRCode({
            onScaned: ({ code }) => {
                this.setState({ query: code, pageCount: 10, page: 1 })
                this.handleSearch()
            }
        })
    }

    GetInstrumentUsageList = (row) => {
        const { query } = this.state
        if (!query) {
            this.setState({ instrumentUsageList: [], totalCount: 0 })
        } else {
            Tyan.doPostEvent('GetInstrumentUsageListWx', {
                data: { row, query, },
                onRequest: () => {
                    this.setState({ loading: true })
                },
                onEnd: ({ errorMessage, bExternal, query, queryText, nameText, instrumentUsageList, totalCount }) => {
                    if (errorMessage) {
                        this.setState({ errorMessage })
                        return
                    }
                    this.setState({ loading: false, bExternal, query, queryText, nameText, instrumentUsageList, totalCount })
                }
            })
        }
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetInstrumentUsageList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetInstrumentUsageList(pageCount)
    }

    handleAdd = () => {
        const { query } = this.state
        location.hash = `/InstrumentUsageInfo/${query}/0`
    }

    handleChildTap = (id) => {
        const { query } = this.state
        location.hash = `/InstrumentUsageInfo/${query}/${id}`
    }

    render() {
        const { errorMessage, bExternal, instrumentUsageList, query, queryText, nameText, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!instrumentUsageList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                {nameText && <Container layout={{ type: "vbox" }} style={style.outer} scrollable >{"　" + nameText}</Container>}
                <Toolbar shadow={false} docked="top" padding="0" margin="0">
                    <SearchField ui="faded" placeholder="扫一扫" margin="0 20 0 20" value={queryText} readOnly={true} /* onChange={this.handleChange} */ />
                    <Button align="right" ui="action" margin="0 20 0 20" iconCls={"x-fa fa-qrcode"} handler={this.handleScanQRCode} />
                    {!bExternal && nameText && <Button align="right" ui="action" iconCls={"x-fa fa-plus"} handler={this.handleAdd} />}
                </Toolbar>
                <ListItem dataList={instrumentUsageList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default InstrumentUsageQuery